module.exports = __webpack_public_path__ + "media/components/assets/euljiro_logo_top-37ccd53e33c105f387754747c7f71fa5.svg";